import React, { ReactNode, useContext, useEffect, useRef, useState } from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
import { useTranslations } from 'next-intl';
import Divider from '@/components/common/Divider';
import useWindowDimensions from '@/functions/useWindowDimensions';
import DropBackShadow from '@/components/structure/DropBackShadow';
import { useLayoutContext } from '@/context/LayoutContext';

interface MenuTemplateProps {
  headChild?: ReactNode;
  sectionSub?: string | ReactNode;
  children?: ReactNode;
  className?: string;
  listClassName?: string;
  headClassName?: string;
  // showRtlAnimation?: boolean;
}
export default function MenuTemplate({
  headChild = null,
  sectionSub = null,
  children = null,
  className = '',
  listClassName = '',
  headClassName = '',
  // showRtlAnimation = false,
}: MenuTemplateProps) {
  const { width } = useWindowDimensions();
  const [showMenu, setShowMenu] = useState(true);
  const { showOverflow, setShowOverflow, dir } = useLayoutContext();
  let showRtlAnimation = dir == 'rtl';
  const toggleMenu = () => {
    if (width && width < 1001) {
      setShowOverflow(!showOverflow);
      setShowMenu(!showMenu);
    } else {
      setShowOverflow(true);
      setShowMenu(true);
    }
  };

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (width && width < 1001) {
      setShowMenu(false);
      setShowOverflow(true);
    } else {
      setShowMenu(true);
    }
  }, [width]);
  console.log('showMenu==', showMenu, showOverflow);
  return (
    <div className={`${styles.container} ${className}`} ref={containerRef}>
      <div className={`${styles.head} ${headClassName}`} onClick={toggleMenu}>
        {/* <div className={`${styles.historyTitleMobile}`}>
          {headIcon}
          <p className={`${styles.title}`}>{title}</p>
        </div>
        <div>{headChild}</div> */}
        {headChild}
      </div>

      {sectionSub && (
        <>
          {sectionSub}
          {/* <Divider className={`${styles.divider}`} />
      <p className={`${styles.historyTitle}`}>{sectionSubTitle}</p> */}
        </>
      )}

      <>
        {!showOverflow && (
          <DropBackShadow
            onClick={() => {
              setShowOverflow(true);
              setShowMenu(false);
            }}
            className={`${styles.dropShadow}`}
          />
        )}
        <div
          className={`${styles.listContainer} ${showRtlAnimation && styles.listContainerRtl} ${showMenu && `${styles.animationShow} ${showRtlAnimation && styles.animationShowRtl}`} ${listClassName}`}
        >
          {children}
        </div>
      </>
    </div>
  );
}
